import { ENVIRONMENTS } from './environment';
import {
  getStatsigConsoleLogCaptureSettings,
  StatsigConsoleLogCaptureSettings,
} from './statsigAutoCapture';

export interface AppConfig {
  STATSIG_CLIENT_SECRET: string;
  STATSIG_CLIENT_USER_ID: string;
  STATSIG_CONSOLE_LOG_CAPTURE_SETTINGS?: StatsigConsoleLogCaptureSettings;
  GTM_ID: string;
  GA4_MEASUREMENT_ID?: string;
  ENVIRONMENT: ENVIRONMENTS;
}

const STATSIG_CLIENT_SECRET = process.env.REACT_APP_STATSIG_CLIENT_SECRET;

if (!STATSIG_CLIENT_SECRET) {
  throw new Error('process.env.REACT_APP_STATSIG_CLIENT_SECRET undefined');
}

const STATSIG_CLIENT_USER_ID = process.env.REACT_APP_STATSIG_CLIENT_USER_ID;

if (!STATSIG_CLIENT_USER_ID) {
  throw new Error('process.env.REACT_APP_STATSIG_CLIENT_USER_ID undefined');
}

const GTM_ID = process.env.REACT_APP_GTM_ID;

if (!GTM_ID) {
  throw new Error(
    'REACT_APP_GTM_ID is missing or empty. Please set the environment variable.',
  );
}

const ENVIRONMENT =
  (process.env.REACT_APP_ENVIRONMENT as ENVIRONMENTS) ??
  ENVIRONMENTS.development;

const GA4_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID?.trim();

const STATSIG_CONSOLE_LOG_CAPTURE_SETTINGS =
  getStatsigConsoleLogCaptureSettings(process.env);

export const CONFIG: AppConfig = {
  STATSIG_CLIENT_SECRET,
  STATSIG_CLIENT_USER_ID,
  STATSIG_CONSOLE_LOG_CAPTURE_SETTINGS,
  GTM_ID,
  GA4_MEASUREMENT_ID,
  ENVIRONMENT,
};

export const IS_PROD = ENVIRONMENT === ENVIRONMENTS.production;
